var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHr = function SvgHr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.75 9.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m3.372 1.75a2.75 2.75 0 1 0-4.244 0A4.75 4.75 0 0 0 1.25 15.5a.75.75 0 0 0 1.5 0 3.25 3.25 0 0 1 5.691-2.146A4.73 4.73 0 0 0 7.25 16.5a.75.75 0 0 0 1.5 0 3.25 3.25 0 0 1 6.5 0 .75.75 0 0 0 1.5 0c0-1.207-.45-2.308-1.191-3.146A3.25 3.25 0 0 1 21.25 15.5a.75.75 0 0 0 1.5 0 4.75 4.75 0 0 0-2.628-4.25 2.75 2.75 0 1 0-4.244 0 4.8 4.8 0 0 0-1.477 1.15 5 5 0 0 0-.279-.15 2.75 2.75 0 1 0-4.244 0 5 5 0 0 0-.279.15 4.8 4.8 0 0 0-1.477-1.15m2.628-.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M18 8.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5",
    clipRule: "evenodd"
  })));
};
export default SvgHr;